<template lang="pug">
  v-dialog(v-model='dialogSchemaProAdd', persistent='', max-width='60%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Agregar Especificaciones
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12', sm='12', md='4')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}", v-model='form.presentacion', label='Presentación', :items='presentaciones', outlined, dense)
                      template(v-slot:prepend-item)
                        v-list(dense)
                          v-list-item( @click='presentacionM = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Presentación
                    presentacion-prod-m(:dialog='presentacionM', :editedIndex='-1', @close='presentacionM = false', @save='listarPresentaciones')
                  v-col(cols='12' sm='12' md='4')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}", v-model='form.idFabricante', label='Fabricante' :items='idFabricanteArray', @change='fabricanteSeleccionado', dense, outlined)
                      template(v-slot:prepend-item)
                        v-list(dense)
                          v-list-item( @click='fabri = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Fabricante
                    Fabricante-m(:dialog='fabri' :editedIndex='-1' @close='fabri = false' @save='listarFabricantes')
                  v-col(cols='12' sm='12' md='4')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}", v-model='form.idMarca', label='Marca', :items='idMarcaArray', persistent-hint hint="Seleccione un Fabricante", dense, outlined)
                v-row(dense)
                  v-col(cols='12', sm='12', md='4')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}", v-model='form.codPortafolio', label='Portafolio', :items='portafolios', dense, outlined)
                      template(v-slot:prepend-item)
                        v-list(dense)
                          v-list-item( @click='porta = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Portafolio
                    Portafolio-m(:dialog='porta' :editedIndex='-1' @close='porta = false' @save='listarPortafolios')
                  v-col(cols='12' sm='12' md='4')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}" v-model='form.idLinea', label='Categoria', :items='idLineaArray', dense, outlined, @change="lineaSeleccionada")
                      template(v-slot:prepend-item)
                        v-list(dense)
                          v-list-item( @click='lin = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Categoria
                    LineaM(:dialog='lin' :editedIndex='-1' @close='lin = false' @save='listarLineas')
                  v-col(cols='12' sm='12' md='4')
                    v-autocomplete(autocomplete="off", v-model='form.sublinea', label='SubCategoria', :items='sublineaArray', persistent-hint hint="Seleccione una Categoria", dense, outlined)
                v-row(dense v-if='mostrar === true')
                  v-col(cols='12' sm='12' md='6')
                    v-autocomplete(autocomplete="off", :menu-props="{closeOnContentClick: true}", v-model='form.idAlmacen', label='*Almacen', :items="almacenes",  outlined, dense)
                      template(v-slot:prepend-item)
                        v-list(dense)
                          v-list-item( @click='alm = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Almacen
                    AlmacenM(:dialog='alm' :editedIndex='-1' @close='alm = false' @save='listarAlmacenes')
                  v-col(cols='12' sm='12' md='6')
                    v-select(v-model='form.idIva' :items="ivas" label='*IVA' dense outlined)
      v-card-actions
        v-spacer
        v-btn(color='error', small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='mostrar === true' color='success', small dark @click='savePre')
          v-icon mdi-content-save
          | Guardar
        v-btn(v-if='mostrar === false' color='success', small dark @click='savePre2')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
import PresentacionProdM from './PresentacionProdM'
import PortafolioM from './PortafolioM'
import FabricanteM from './FabricanteM'
import LineaM from './LineaM'
import AlmacenM from './AlmacenM'

export default {
  props: ['dialogSchemaProAdd', 'editedIndex', 'FormPadre', 'mostrar'],
  data: () => ({
    //fabricante y marca
    fabricantes: [],
    idFabricanteArray: [],
    idMarcaArray: [],
    //linea sublinea
    lineas: [],
    idLineaArray: [],
    sublineaArray: [],
    // resto de atributos
    presentaciones: [],
    portafolios: [],
    almacenes: [],
    ivas: [],
    // permisos
    permisosPortafolio: {},
    permisosLinea: {},
    permisosAlmacen: {},
    permisosFabricante: {},
    // activar modales
    presentacionM: false,
    porta: false,
    fabri: false,
    lin: false,
    alm: false,
    form: {
        _id: '',
        codPortafolio: null,
        idFabricante: null,
        idMarca: null,
        idLinea: null,
        sublinea: null,
        presentacion: null,
        idAlmacen: null,
        idIva: null
    },
    defaultForm: {
        _id: '',
        codPortafolio: null,
        idFabricante: null,
        idMarca: null,
        idLinea: null,
        sublinea: null,
        presentacion: null,
        idAlmacen: null,
        idIva: null
    },
  }),

  components: {
    PresentacionProdM,
    PortafolioM,
    FabricanteM,
    LineaM,
    AlmacenM
  },

  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        Object.keys(this.form).map(key => {
          if (val[key]) this.form[key] = val[key]
        })
        if (val.idFabricante) {
          this.fabricanteSeleccionado(val.idFabricante)
        }
        if (val.idLinea) {
          this.lineaSeleccionada(val.idLinea)
        }
      }
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarAlmacenes()
      this.cargarIVA()
      this.listarLineas()
      this.listarPresentaciones()
      this.listarPortafolios()
      this.listarFabricantes()
      /* this.permisosAlmacen = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Almacen')
      this.permisosFabricante = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Fabricante')
      this.permisosPortafolio = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Portafolio')
      this.permisosLinea = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Linea') */
    },

    listarPresentaciones () {
      Api.get('presentacionProd')
        .then(response => {
          response.data.map(data => {
            this.presentaciones.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarPortafolios () {
      Api.get('portafolio')
        .then(response => {
          response.data.map(data => {
            this.portafolios.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarFabricantes () {
      Api.get('fabricante')
        .then(response => {
          this.fabricantes = response.data
          this.fabricantes.map(data => {
            this.idFabricanteArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarLineas () {
      Api.get('/linea')
        .then(response => {
          this.lineas = response.data
          this.lineas.map(data => {
            this.idLineaArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          response.data.map(data => {
            this.almacenes.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    cargarIVA () {
      Api.get('iva')
        .then(response => {
          response.data.map(data => {
            this.ivas.push({
              text: data.descripcion,
              value: data._id,
              valor: data.valor
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    
    fabricanteSeleccionado (data) {
      const fabriselec = this.fabricantes.find(
        fabriselec => fabriselec._id === data
      )
      this.form.idFabricante = fabriselec._id
      this.idMarcaArray = []
      for (let i = 0; i < fabriselec.marca.length; i++) {
        this.idMarcaArray.push({
          text: fabriselec.marca[i].nombre,
          value: fabriselec.marca[i]._id
        })
      }
    },

    lineaSeleccionada (data) {
      const sub = this.lineas.find(sub => sub._id === data)
      this.sublineaArray = []
      for (let i = 0; i < sub.subLinea.length; i++) {
        this.sublineaArray.push(sub.subLinea[i].descripcion)
      }
    },
    
    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },

    validarCampos () {
      if (this.mostrar === true && (this.form.idAlmacen === null || this.form.idIva === null) ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor, verifique y llene todos los campos con * para continuar'
        })
        return true
      } 
      return false
    },

    savePre () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        Api.put('producto/ProSchema', this.form)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.$emit('edited')
            this.close()

          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    },

    savePre2 () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        Api.put('producto/ProSchema2', {
          _id: this.form._id,
          presentacion: this.form.presentacion, 
          idFabricante: this.form.idFabricante, 
          idMarca: this.form.idMarca, 
          codPortafolio: this.form.codPortafolio,
          idLinea: this.form.idLinea,
          sublinea: this.form.sublinea }
        )
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.$emit('edited')
            this.close()

          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
  
}

</script>